import React from "react";
import { SVG_ICON } from "./svgIcon";

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const MAIL_STATUS_CONFIG = {
  sent: {
    svg: SVG_ICON?.sentTrack,
    color: "#93a5ff"
  },
  opened: {
    svg: SVG_ICON?.openTrack,
    color: "#5b82ff"
  },
  clicked: {
    svg: SVG_ICON?.clickTrack,
    color: "var(--hyperlink)"
  },
  replied: {
    svg: SVG_ICON?.replyTrack,
    color: "#2438b5"
  },
  received_email: {
    svg: SVG_ICON?.replyTrack,
    color: "#2438b5"
  },
  bounced: {
    svg: SVG_ICON?.bouncedTrack,
    color: "#7c88b8"
  },
  optout: {
    svg: SVG_ICON?.optedOutTrack,
    color: "#16224f"
  },
  opted_out: {
    svg: SVG_ICON?.optedOutTrack,
    color: "#16224f"
  },
  meeting_booked: {
    svg: SVG_ICON?.meetingBooked,
    color: "#1d2a6b"
  },
  auto_reply: {
    svg: SVG_ICON?.autoReply,
    color: "#1d2a6b"
  },
  li_message_sent: {
    svg: SVG_ICON?.sentTrack,
    color: "#0a66c2"
  },
  li_connection_req_sent: {
    svg: SVG_ICON?.liCrSent,
    color: "#4a90e2"
  },
  li_connection_req_accepted: {
    svg: SVG_ICON?.liCrAccepted,
    color: "#0a66c2"
  },
  li_replied: {
    svg: SVG_ICON?.liReplied,
    color: "var(--hyperlink )"
  }
};

export const DROPDOWN_LIST = [
  {
    key: "unopened",
    label: "Not Opened"
  },
  {
    key: "opens",
    label: "Opens"
  },
  {
    key: "clicks",
    label: "Clicks"
  },
  {
    key: "replied",
    label: "Replied"
  },
  {
    key: "bounced",
    label: "Bounced"
  },
  {
    key: "optedOut",
    label: "Opted Out"
  }
];
